.page {
  padding: var(--space-4, 1rem);
  max-width: 60rem;
  margin: 0 auto;
}

.header {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
}

.sectionTitle {
  font-size: 1rem;
  margin: 1rem 0 0.5rem;
}

.inviteForm {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: var(--card);
  border: 1px solid var(--paper-2);
  border-radius: var(--radius-soft);
  padding: 1rem;
}

/*
 * `SPEC-ONB-001 §3b`. Two structurally separate blocks, not two options in
 * one dropdown — the external row carries its own visual weight so an admin
 * cannot select it on autopilot the way a dropdown item invites.
 */
.whoGroup {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.whoOption {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: var(--radius-soft);
  border: 1px solid var(--paper-2);
}

.whoOption[data-external='true'] {
  border-color: var(--warn);
  background: var(--paper-2);
}

.adminConfirm {
  display: flex;
  align-items: flex-start;
  gap: 0.5rem;
  font-size: var(--text-min-body, 0.875rem);
  color: var(--stop);
}

.targetRow {
  display: grid;
  grid-template-columns: 12rem 1fr;
  gap: 0.75rem;
}

@media (max-width: 560px) {
  .targetRow {
    grid-template-columns: 1fr;
  }
}

.hint {
  font-size: var(--text-min-body, 0.875rem);
  color: var(--muted);
  margin: 0;
}

.error {
  color: var(--stop);
  font-size: var(--text-min-body, 0.875rem);
  margin: 0;
}

.confirmRow {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  align-items: flex-start;
}
